'use strict';

var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');

/**
 * 组件
 */
var QRCode = React.createClass({
  render: function () {
    return (<img className="component-SimpleCom"
                 src={assetsHelper.getComponentAsset('QRCode')}
    />);
  }
});

module.exports = QRCode;



// WEBPACK FOOTER //
// ./src/views/Components/QRCode.jsx